import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import images from './images/images';
import {isMobile, isBrowser} from 'react-device-detect';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import gaParams from '../../../../utilities/analytics/constants';
import './StickyFooter.scss';

export default function StickyFooter({}) {
  const upperTxt = `זמינים עבורכם 24/7 מהארץ ומהעולם`;
  const bottomTxt = `וואטסאפ ${window.Config.whatsAppSelfCare}`;
  const bottomTxtSecondNumber = `שיחת חינם  ${window.Config.numberCallCenterAbroad}`;

  function reportGAOnClick() {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_CLICK_STICKY_FOOTER.category,
      gaParams.ABROAD_MY_ABROAD_CLICK_STICKY_FOOTER.eventType,
      gaParams.ABROAD_MY_ABROAD_CLICK_STICKY_FOOTER.eventParams
    );
  }

  return (
    <div className='my-abroad-sticky-footer'>
      {isMobile ? (
        <>
          <div style={{fontSize: '12px', color: '#4a4a4a', marginBottom: '5px'}}>{upperTxt}</div>
          <a className='button-call' href={`tel:${window.Config.numberCallCenterAbroad.replace('-', '')}`} onClick={() => reportGAOnClick()}>
            <Image src={require('./images/Whatsapp.svg')} alt='wa' style={{marginLeft: '5px'}} />
            <span style={{fontWeight: 'bold', color: 'var(--theme-primary, #9631ff)'}}>{bottomTxt}</span>
            <Image src={images.phoneCall} alt='phone' style={{marginLeft: '5px'}} />
            <span style={{fontWeight: 'bold', color: 'var(--theme-primary, #9631ff)'}}>{bottomTxtSecondNumber}</span>
          </a>
        </>
      ) : (
        <>
          <div style={{fontSize: '16px', color: '#4a4a4a'}}>{upperTxt}</div>
          <div className='button-call'>
            <Image src={require('./images/Whatsapp.svg')} alt='wa' style={{marginLeft: '5px'}} />
            <span style={{fontWeight: 'bold', color: 'var(--theme-primary, #9631ff)'}}>{bottomTxt}</span>
          </div>
          <div className='button-call'>
            <Image src={images.phoneCall} alt='phone' style={{marginLeft: '5px'}} />
            <span style={{fontWeight: 'bold', color: 'var(--theme-primary, #9631ff)'}}>{bottomTxtSecondNumber}</span>
          </div>
        </>
      )}
    </div>
  );
}
